import { render, staticRenderFns } from "./DefaultMembers.vue?vue&type=template&id=8816b3c8&scoped=true&"
import script from "./DefaultMembers.vue?vue&type=script&lang=js&"
export * from "./DefaultMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8816b3c8",
  null
  
)

export default component.exports